/**
 * The publisher's processing animation from `theme.general.loaderAnimation`.
 * Mirrors the store's `resolveCustomLoaderAnimation`: the theme default
 * Lottie counts as "nothing configured" so untouched publishers keep the
 * built-in spinner.
 */
const BUILT_IN_LOADER_ANIMATION_PATTERN = /\/defaults\/circular-loader\.json(\?.*)?$/i;

export const getCustomLoaderAnimation = (
  url: string | null | undefined
): string | undefined => {
  const trimmed = url?.trim();
  if (!trimmed || BUILT_IN_LOADER_ANIMATION_PATTERN.test(trimmed)) return undefined;
  return trimmed;
};

export type LoaderAnimationKind = 'lottie' | 'video' | 'unknown';

/**
 * By extension when there is one. Media-library URLs carry none
 * (`/media/<id>/<timestamp>__<uuid>`), so `unknown` means "fetch it and decide
 * from the Content-Type".
 */
export const getLoaderAnimationKind = (url: string): LoaderAnimationKind => {
  const path = url.split(/[?#]/, 1)[0];
  if (/\.webm$/i.test(path)) return 'video';
  if (/\.json$/i.test(path)) return 'lottie';
  return 'unknown';
};

export const isVideoContentType = (contentType: string | null): boolean =>
  /^video\//i.test((contentType ?? '').trim());
